import { ConfigurationActionNames, ConfigurationActionTypes, ConfigurationState } from './types';

const initialState = {
  endofDayReportTime: {
    desiredSetting: {
      endOfDay: '',
    },
  },
  locator: {
    desiredSetting: {
      reportingInterval: null,
      lowTempThreshold: null,
      highTempThreshold: null,
      motionDetectionThreshold: null,
      enableMotionDetect: false,
    },
  },
};

export const configurationReducer = (
  state: ConfigurationState = initialState,
  action: ConfigurationActionTypes,
): ConfigurationState => {
  switch (action.type) {
    case ConfigurationActionNames.SET_DEVICE_CONFIGURATION: {
      return {
        ...state,
        locator: action.payload.locator,
        endofDayReportTime: action.payload.endofDayReportTime,
      };
    }
    default:
      return state;
  }
};
